"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PageEnd = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/PageEnd"));

// Generated by script, don't edit it please.
var PageEnd = (0, _createSvgIcon["default"])({
  as: _PageEnd["default"],
  ariaLabel: 'page end',
  category: 'direction',
  displayName: 'PageEnd'
});
var _default = PageEnd;
exports["default"] = _default;
module.exports = exports.default;